import { ChartModel } from './chart.model';
/**
 * Area chart model definition
 */
export class AreaChartModel extends ChartModel {
/**
 * Defines if the chart is stacked. Default: false.
 */
autoScale?: boolean;
/**
 * Set the minimum value of the y axis to the minimum value in the data, instead of 0. Default: false.
 */
stacked?: boolean;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super();
    Object.assign(this, values);
  }
}

function AreaChartModel_tsickle_Closure_declarations() {
/**
 * Defines if the chart is stacked. Default: false.
 * @type {?}
 */
AreaChartModel.prototype.autoScale;
/**
 * Set the minimum value of the y axis to the minimum value in the data, instead of 0. Default: false.
 * @type {?}
 */
AreaChartModel.prototype.stacked;
}

